import { Injectable, signal, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FIDService {
  
  determineBankFid(bank_fid: number | undefined | null, selectedFid: number) {
    let fid: number = 0;
    if(selectedFid > 0) {
      if(bank_fid && bank_fid > 0) {
        fid = bank_fid 
      }
      else {
        fid = selectedFid
      }
    }
    return fid;
  }
}
